import axios from 'axios'

import type {
	GridActionResponse,
	GridEndpoints,
	GridFetchResponse,
	GridInlineCreateResponse,
	GridInlineSaveResponse,
	GridRequestPayload,
} from '../types'

export class GridApi {
	private readonly endpoints: GridEndpoints

	constructor(endpoints: GridEndpoints) {
		this.endpoints = endpoints
	}

	async fetch(payload: GridRequestPayload): Promise<GridFetchResponse> {
		const { data } = await axios.post<GridFetchResponse>(this.endpoints.fetch, payload)
		return data
	}

	async action(actionKey: string, rowId: string | number): Promise<GridActionResponse> {
		const { data } = await axios.post<GridActionResponse>(this.endpoints.action, { actionKey, rowId })
		return data
	}

	async groupAction(actionKey: string, rowIds: ReadonlyArray<string | number>): Promise<GridActionResponse> {
		const { data } = await axios.post<GridActionResponse>(this.endpoints.groupAction, {
			actionKey,
			rowIds,
		})
		return data
	}

	async inlineSave(rowId: string | number, values: Record<string, unknown>): Promise<GridInlineSaveResponse> {
		const { data } = await axios.post<GridInlineSaveResponse>(this.endpoints.inlineSave, { rowId, values })
		return data
	}

	async inlineCreate(values: Record<string, unknown>): Promise<GridInlineCreateResponse> {
		const { data } = await axios.post<GridInlineCreateResponse>(this.endpoints.inlineCreate, { values })
		return data
	}

	exportUrl(): string {
		return this.endpoints.export
	}
}
